<div id="icc-main-container" [class]="project + '-theme'">
  @if (!isHandset && !openedPreview && !configuratorOptions?.embeddedInB2B) {
    <mat-toolbar color="primary" id="main-toolbar" class="mat-elevation-z4">
      <span id="icc-logo">
        <img [src]="logo">
      </span>
      <span id="icc-version">
        {{ currentApplicationVersion }}
      </span>
      <div class="spacer"></div>
      @for (option of additionalReturnButtons; track option) {
        <button [disabled]="!(savingButton$ | async)" mat-icon-button (click)="saveConfiguration(option)" [title]="RETURN_BUTTON_ENUM[option.returnButton]">
          <mat-icon [fontIcon]="option.materialIcon" matListIcon>
            {{option.materialIcon || 'bubble_chart'}}
          </mat-icon>
        </button>
      }
      @if (navigationBackButtonAvailable()) {
        <button (click)="backIconClick()" mat-icon-button>
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      @if (navigationBackButtonAvailable()) {
        <button (click)="homeIconClick($event)" mat-icon-button>
          <mat-icon>home</mat-icon>
        </button>
      }
      @if (showBrowserLanguageSettings()) {
        <button mat-flat-button [matMenuTriggerFor]="showCountryLanguages" style="width: auto; padding-right: 1%;">
          <mat-icon>flag</mat-icon>
          {{selectedLanguage}}
        </button>
        <mat-menu #showCountryLanguages="matMenu" xPosition="before">
          @for (language of languages | keyvalue; track language) {
            @if (selectedLanguage !== language.value) {
              <button mat-menu-item (click)="changeLanguage(language.key)">{{language.value}}</button>
            }
          }
        </mat-menu>
      }
      @if (showCurrenciesSelect()) {
        <button  mat-flat-button [matMenuTriggerFor]="showCurrenciesSelect" style="width: auto;">
          <mat-icon>monetization_on</mat-icon>
          {{selectedCurrency.currency_name}}
        </button>
        <mat-menu #showCurrenciesSelect="matMenu" xPosition="before">
          @for (currency of currencies; track currency) {
            @if (selectedCurrency.id !== currency.id) {
              <button mat-menu-item (click)="changeCurrency(currency.id)">{{currency.currency_name}}</button>
            }
          }
        </mat-menu>
      }
      <!-- Dodanie menu do zmiany waluty -->
    </mat-toolbar>
  }
  @if (!(configuratorInitialized$ | async) || !(savingButton$ | async)) {
    <mat-progress-bar mode="indeterminate" color="primary" @progressBar></mat-progress-bar>
  }
  <div class='icc-container'
    [class.full-sidenav]="!isDesktop && !isTablet && !isHandset"
    [class.small-sidenav]="isDesktop || isTablet"
    [class.mobile-sidenav]="isHandset"
    [class.visible-preview]="!isSmallDesktop && !isTablet && !isHandset"
    [class.hidden-preview]="isSmallDesktop || isTablet || isHandset || isFullscreen"
    [class.embedded-in-b2b]="configuratorOptions?.embeddedInB2B"
    >
    <div class="steps mat-elevation-z1">

      <mat-sidenav-container autosize>
        <mat-sidenav #snav class='sidenav' id="steps-sidenav" [mode]="isHandset ? 'over' : 'side'" [fixedInViewport]="isHandset" [disableClose]="!isHandset && (hasSteps$ | async)"
          [opened]="!isHandset && (hasSteps$ | async)" class="mat-elevation-z3">
          <mat-nav-list>
            @for (step of (steps$ | async); track step; let i = $index) {
              <mat-list-item (click)="switchStep(step.id)" [class.step-active]="currentStepId === i">
                <mat-icon [fontSet]="step.stepIcon?.fontSet" [fontIcon]="step.stepIcon?.fontIcon"
                  matListIcon>{{step.stepIcon?.ligature}}
                </mat-icon>
                <span matLine translate [class.icc-ph]="translationLoading">{{step.stepName}}</span>
              </mat-list-item>
            }
            @if (isHandset) {
              <div>
                @for (option of additionalReturnButtons; track option) {
                  <mat-list-item (click)="saveConfiguration(option)" mat-icon-button>
                    <mat-icon matListIcon>{{ option.materialIcon || 'bubble_chart' }}</mat-icon>
                    <span matLine translate [class.icc-ph]="translationLoading">{{ RETURN_BUTTON_ENUM[option.returnButton] }}</span>
                  </mat-list-item>
                }
              </div>
            }
            @if (isHandset && homeIconAvailable()) {
              <mat-list-item class='sidenav__home' (click)="homeIconClick($event)" mat-icon-button>
                <mat-icon   matListIcon>home</mat-icon>
                @if (configuratorOptions && configuratorOptions.homeButtonText) {
                  <span matLine translate [class.icc-ph]="translationLoading">{{configuratorOptions.homeButtonText}}</span>
                }
              </mat-list-item>
            }
          </mat-nav-list>
        </mat-sidenav>

        <mat-sidenav-content>
          <mat-toolbar id="step-toolbar" class="mat-elevation-z2" [@search]="searching">
            @if (isHandset && !pageTitle) {
              <button mat-icon-button (click)="snav.toggle()">
                <mat-icon>menu</mat-icon>
              </button>
            }
            @if (pageTitle) {
              <button mat-icon-button class="arrow-back" (click)="closePage()">
                <mat-icon>arrow_back</mat-icon>
              </button>
            }
            @if (stepDescriptionEnabled) {
              <div class="toolbarIcons">
                <button mat-icon-button (click)="openInfoModal()">
                  <mat-icon>help_outline</mat-icon>
                </button>
              </div>
            }
            @if (!pageTitle && !searching) {
              <h1 [class.icc-ph-accent]="translationLoading"
                [style.width.%]="((accessories?.categories?.length > 1 || accessories?.subcategories?.length > 1) && isFilterByCategoriesOptionSelected()) ? '0' : '100'"
                >{{stepTitle | translate}}
              </h1>
            }
            @if (pageTitle && !searching) {
              <h1 [class.icc-ph-accent]="translationLoading"
                [style.width.%]="((accessories?.categories?.length > 1 || accessories?.subcategories?.length > 1) && isFilterByCategoriesOptionSelected()) ? '0' : '100'"
                >{{pageTitle | translate}}
              </h1>
            }
            
            <div class="wrapper">
              @if (!searching && (accessories?.categories?.length > 1 || accessories?.subcategories?.length > 1)) {
                <div class="filter"
                  >
                  @if (accessories?.categories?.length > 1) {
                    <div class="filter__accessory-category">
                      <mat-form-field class="filter__accessory-category-form">
                        <mat-label>{{ 'CONFIGURATOR|Kategorie' | translate }}</mat-label>
                        <mat-select [value]="selectedCategory.name">
                          @for (category of accessories.categories; track category) {
                            <mat-option class="filter__accessory-category-form__option" [value]="category.name"
                              (click)="changeCategory(category)">
                              {{category.name}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  @if (showSubcategories()) {
                    <div class="filter__accessory-subcategory">
                      <mat-form-field appearance="none" class="filter__accessory-subcategory-form">
                        <mat-label> {{ "CONFIGURATOR|Podkategorie" | translate }}</mat-label>
                        <mat-select [value]="selectedSubCategory.name">
                          @for (subcategory of accessories.subcategories; track subcategory) {
                            <mat-option class="filter__accessory-category-form__option" [value]="subcategory.name"
                              (click)="changeSubcategory(subcategory)">
                              {{subcategory.name}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                </div>
              }
              @if (isDefaultConfigurationAvailable()) {
                <div>
                  <button mat-button (click)="confirmSettingDefaultConfiguration()">
                    {{ 'CONFIGURATOR|Ustawienia domyślne' | translate }}
                  </button>
                </div>
              }
              @if (searching) {
                <div id="search">
                  <mat-form-field class="search-input" floatLabel="never">
                    <mat-label translate>INTERFACE|Wyszukaj</mat-label>
                    <input matInput type="search" [formControl]="searchControl" #searchInput>
                    <button matPrefix mat-icon-button>
                      <mat-icon>search</mat-icon>
                    </button>
                    <button matSuffix mat-icon-button (click)="stopSearching()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              }
              @if (!searching) {
                <div class="spacer"></div>
              }
              @if (!searching) {
                <div class="toolbarIcons">
                  @for (option of pageToolbarOptions; track option) {
                    <button [ngClass]="option.hover === 'active' ? 'hover' : ''" mat-button (click)="menuItemHandler(option)" [title]="option.title | translate">
                      <mat-icon [fontSet]="option.icon?.fontSet" [fontIcon]="option.icon?.fontIcon" matListIcon>
                        {{option.icon?.ligature || 'bubble_chart'}}
                      </mat-icon>
                      @if (!(accessories?.categories?.length > 1)) {
                        <span translate>{{ option.title }}</span>
                      }
                    </button>
                  }
                  @if (pageMenuOptions.length) {
                    <button mat-icon-button [matMenuTriggerFor]="pageMenu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
          </mat-toolbar>
          @if ((openedMessage$ | async); as message) {
            <div #pageBanner id="banner-container" class="mat-elevation-z1"
              @messageTrigger (@messageTrigger.done)="resizeDraw()">
              @if (!message.messageSafe) {
                <div id="banner-container-message" [innerHtml]="message.message"></div>
              }
              @if (message.messageSafe) {
                <div id="banner-container-message" [innerHtml]="message.messageSafe"></div>
              }
              <div id="banner-container-actions">
                <button mat-button color="primary" (click)="dismissMessage()">OK</button>
              </div>
            </div>
          }
          <div #pageContainer id="page-container"></div>
          @if ((isSmallDesktop || isTablet || isHandset) && !isSummaryHidden || forceReturnButton) {
            <ng-container [ngTemplateOutlet]="summary" [ngTemplateOutletContext]="{price: price}"></ng-container>
          }
          @if ((hasSteps$ | async) && !isStepperHidden && !pageTitle) {
            <div id="stepper" class="mat-elevation-z3">
              <span class="arrow-button">
                <button mat-icon-button (click)="goToPreviousStep()">
                  <mat-icon>west</mat-icon>
                </button>
              </span>
              @if (isHandset) {
                @for (step of (steps$ | async); track step; let i = $index) {
                  <button mat-button class="stepper-step" (click)="switchStep(step.id)"
                    [class.selected]="(selectedStep$ | async).id === step.id">
                    {{i + 1}}
                  </button>
                }
              }
              @if (!isHandset) {
                <span id="step-counter" [class.icc-ph-accent]="translationLoading">
                {{(selectedStep$ | async)?.stepIndex + 1}}&nbsp;/&nbsp;{{(steps$ | async).length}}</span>
              }
              <span class="arrow-button">
                @if (!isHandset && !isLastStep()) {
                  <button mat-flat-button color="primary" (click)="goToNextStep()">
                    {{ 'INTERFACE|Dalej' | translate }}
                    <mat-icon>east</mat-icon>
                  </button>
                }
                @if (isHandset && !isLastStep()) {
                  <button mat-icon-button (click)="goToNextStep()">
                    <mat-icon>east</mat-icon>
                  </button>
                }
              </span>
            </div>
          }
        </mat-sidenav-content>

        <mat-sidenav #sideFilters id="filters-sidenav" position="end" [mode]="'over'" [fixedInViewport]="isHandset"
          class="mat-elevation-z3">
          <div #filtersContainer id="filters-container"></div>
        </mat-sidenav>

      </mat-sidenav-container>
    </div>
    <div class="main" [class.opened]="openedPreview && (isSmallDesktop || isTablet || isHandset || isFullscreen)" >
      @if (openedPreview && (isSmallDesktop || isTablet || isHandset || isFullscreen)) {
        <mat-toolbar id="preview-toolbar">
          <button mat-icon-button (click)="closePreview()">
            <mat-icon>west</mat-icon>
          </button>
        </mat-toolbar>
      }
      <div id="main-container">
        <div style="display: none;" class="preview preview-shutter" #previewShutter ng-if="this.drawService.details?.rollerShutter?.system?.addAsSeparatePosition">
          <icc-draw [details]="this.drawService.shutterDetails" [options]="drawOptionsShutterOffer" iccDrawRefresh [parentElement]="previewShutter"></icc-draw>
        </div>
        <div class="preview preview-offer preview-offer--snapshot" #previewOffer [ngClass]="{'flip-symbols': flipSymbols}">
          <icc-draw [details]="this.drawService.details" [options]="drawOptionsOffer" iccDrawRefresh [parentElement]="previewOffer"></icc-draw>
        </div>
        <div class="preview" #preview [ngClass]="{'flip-symbols': flipSymbols}">
          @if (!this.openedConstructionPreview) {
            <icc-draw [details]="this.drawService.details" [options]="drawOptions" [displayType]="DisplayType" (canDraw3d)="get3dAvailable($event)" iccDrawRefresh [parentElement]="preview" [fitTo]="((isSmallDesktop || isTablet || isHandset || isFullscreen) && openedPreview) ? 'width' : 'height'">
            </icc-draw>
          }
          @if (this.openedConstructionPreview) {
            <icc-draw class='zoom_draw' [details]="this.drawService.details" [options]="drawOptions" [displayType]="DisplayType" (canDraw3d)="get3dAvailable($event)" fitTo="width" iccDrawResize [drawWidth]="width$ | async" [drawHeight]="height$ | async" [parentElement]="preview"></icc-draw>
          }
        </div>
        <div class="preview-options">
          @if (!this.openedConstructionPreview) {
            <mat-button-toggle-group name="drawingSide" [ngModel]="this.drawService.options.base.side" (ngModelChange)="switchDrawingSide($event)" [hideSingleSelectionIndicator]="true">
              <mat-button-toggle value="inner">{{ 'DRAW|podgląd wewnętrzny' | translate }}</mat-button-toggle>
              <mat-button-toggle value="outer">{{ 'DRAW|podgląd zewnętrzny' | translate }}</mat-button-toggle>
              @if (this.configuratorOptions?.config?.Drawing.is3dAvailable && this.configuratorOptions?.is3dDrawAvailable && this.drawService.details?.System?.available_3d_draw && isAllDataFor3dAvailable) {
                <mat-button-toggle value="3d">{{ 'DRAW|widok 3D' | translate }}</mat-button-toggle>
              }
            </mat-button-toggle-group>
          }
        </div>
        @if (openedPreview && previewDetails && (isSmallDesktop || isTablet || isHandset || isFullscreen)) {
          <div class="details">
            <icc-details></icc-details>
          </div>
        }
      </div>
      <ng-container [ngTemplateOutlet]="summary" [ngTemplateOutletContext]="{price: price, preview: (isSmallDesktop || isTablet  || isFullscreen) && openedPreview}"></ng-container>
      @if (openedPreview && isHandset && returnButton) {
        <div id="preview-action" class="mat-elevation-z3">
          <button mat-flat-button color="primary" [disabled]="!(savingButton$ | async)"
            (click)="saveConfiguration()" [class.icc-ph-transparent]="translationLoading">
            @switch (returnButton) {
              @case ('ADD') {
                {{ 'INTERFACE|Dodaj' | translate }}
              }
              @case ('SAVE') {
                {{ 'INTERFACE|Zapisz' | translate }}
              }
              @case ('OK') {
                {{ 'INTERFACE|OK' | translate }}
              }
              @case ('GENERATE_THUMBNAIL') {
                {{ 'CONFIGURATOR|Generuj miniaturę' | translate }}
              }
              @case ('ADD_TO_BASKET') {
                {{'CONFIGURATOR|Dodaj do koszyka' | translate}}
              }
              @case ('ADD_TO_OFFER') {
                {{'CONFIGURATOR|Dodaj do oferty' | translate}}
              }
              @case ('PRINT') {
                {{'CONFIGURATOR|Generuj PDF' | translate}}
              }
            }
          </button>
        </div>
      }
    </div>
  </div>
</div>

<mat-menu #pageMenu="matMenu" xPosition="before">
  @for (option of pageMenuOptions; track option) {
    <button mat-menu-item (click)="menuItemHandler(option)" translate>
      @if (option.icon?.ligature) {
        <mat-icon [fontSet]="option.icon?.fontSet" [fontIcon]="option.icon?.fontIcon" matListIcon>
          {{option.icon?.ligature}}
        </mat-icon>
      }
      <span translate>{{ option.title }}</span>
    </button>
  }

  <mat-divider></mat-divider>
</mat-menu>

<ng-template #summary let-price="price" let-preview="preview">
  @if (!this.openedConstructionPreview) {
    <div class="summary mat-elevation-z3" [ngClass]="{'expand': expandSummary}">
      @if (price.discount != 0 && price.showPrice) {
        <button (click)="summaryToggle()" mat-icon-button>
          @if (expandSummary) {
            <mat-icon>keyboard_arrow_down</mat-icon>
          }
          @if (!expandSummary) {
            <mat-icon>keyboard_arrow_up</mat-icon>
          }
        </button>
      }
      <div class="summary-info" [ngClass]="{'extended': price.discount != 0}">
        @if (!hiddenPrice
          && (configuratorOptions.mode !== 'layoutThumbnail'
          && (!price.price || price.price !== price.price)
          && price.showPrice || (isBlockedAddToOffer$  | async))) {
          <span id="price-nodiscount" [class.icc-ph-white]="translationLoading">
            {{ 'CONFIGURATOR|Nie można wycenić konstrukcji' | translate }}
            @if (showConstructionIssuesModalButton) {
              <mat-icon (click)='showConstructionIssuesModal()' class='show-bad-construction-info'
              >help</mat-icon>
            }
          </span>
        }
        @if (expandSummary && configuratorOptions.mode !== 'layoutThumbnail' && price.price && price.discount == 0 && price.promotion !== 0 && price.showPrice && !(isBlockedAddToOffer$  | async)) {
          <span id="price-before-discount" [class.icc-ph-white]="translationLoading">
            {{'CONFIGURATOR|Cena bez promocji' | translate}}: @if (price.listPriceBeforePromotions && price.listPriceBeforePromotions !== price.priceBeforePromotions) {
            <s>{{ price.listPriceBeforePromotions | currency: currency }}</s>
            } {{ price.priceBeforePromotions | currency: currency  }}
          </span>
        }
        @if (configuratorOptions.mode !== 'layoutThumbnail'&& price.price && price.discount == 0 && price.promotion !== 0 && price.showPrice && !(isBlockedAddToOffer$  | async)) {
          <span id="price-discount" [class.icc-ph-white]="translationLoading">
            {{ 'CONFIGURATOR|Cena po promocji' | translate }}:  <span class="price">@if (price.listPriceAfterDiscountsInCurrency && price.listPriceAfterDiscountsInCurrency !== price.priceAfterDiscountsInCurrency) {
            <s>{{ price.listPriceAfterDiscountsInCurrency | currency: currency : '-' : false }}</s>
          } {{ price.priceAfterDiscountsInCurrency  | currency: currency : '-' : false }}</span>
        </span>
      }
      @if (expandSummary && configuratorOptions.mode !== 'layoutThumbnail' && price.price && price.discount != 0 && price.promotion !== 0 && price.showPrice && !(isBlockedAddToOffer$  | async)) {
        <span id="price-before-discount" [class.icc-ph-white]="translationLoading">
          {{'CONFIGURATOR|Cena bez promocji' | translate}}: @if (price.listPriceBeforePromotions && price.listPriceBeforePromotions !== price.priceBeforePromotions) {
          <s>{{ price.listPriceBeforePromotions | currency: currency }}</s>
          } {{ price.priceBeforePromotions | currency: currency  }}
        </span>
      }
      @if (configuratorOptions.mode !== 'layoutThumbnail'&& price.price && price.discount != 0 && price.promotion !== 0 && price.showPrice && !(isBlockedAddToOffer$  | async)) {
        <span id="price-discount" [class.icc-ph-white]="translationLoading">
          {{ 'CONFIGURATOR|Cena po promocji' | translate }}:  <span class="price">@if (price.listPriceAfterDiscountsInCurrency && price.listPriceAfterDiscountsInCurrency !== price.priceAfterDiscountsInCurrency) {
          <s>{{ price.listPriceAfterDiscountsInCurrency | currency: currency : '-' : false }}</s>
        } {{ price.priceAfterDiscountsInCurrency  | currency: currency : '-' : false }}</span>@if (quantity > 1 && showOfferDataInputs) {
        <span> @if (!offerDiscountToPosition) {
          ({{'CONFIGURATOR|Rabat' | translate}}: {{ price.discount}}%)
        }
      </span>
    }
    <br>
      @if (expandSummary && (quantity<=1 || !showOfferDataInputs)) {
        <span>@if (!offerDiscountToPosition) {
          ({{'CONFIGURATOR|Rabat' | translate}}: {{ price.discount}}%)
        }</span>
      }
    </span>
  }
  @if (expandSummary && configuratorOptions.mode !== 'layoutThumbnail' && price.price && price.discount != 0 && price.promotion === 0 && price.showPrice && !(isBlockedAddToOffer$  | async)) {
    <span id="price-before-discount" [class.icc-ph-white]="translationLoading">
      {{'CONFIGURATOR|Cena bez rabatu' | translate}}: @if (price.listPrice && price.listPrice !== price.price) {
      <s>{{ price.listPrice | currency: currency }}</s>
      } {{ price.price | currency: currency  }}
    </span>
  }
  @if (configuratorOptions.mode !== 'layoutThumbnail'&& price.price && price.discount != 0 && price.promotion === 0 && price.showPrice && !(isBlockedAddToOffer$  | async)) {
    <span id="price-discount" [class.icc-ph-white]="translationLoading">
      {{ 'CONFIGURATOR|Cena po rabacie' | translate }}:  <span class="price">@if (price.listPriceAfterDiscountsInCurrency && price.listPriceAfterDiscountsInCurrency !== price.priceAfterDiscountsInCurrency) {
      <s>{{ price.listPriceAfterDiscountsInCurrency | currency: currency : '-' : false }}</s>
    } {{ price.priceAfterDiscountsInCurrency  | currency: currency : '-' : false }}</span>@if (quantity > 1 && showOfferDataInputs) {
    <span> @if (!offerDiscountToPosition) {
      ({{'CONFIGURATOR|Rabat' | translate}}: {{ price.discount}}%)
    }
  </span>
}
<br>
  @if (expandSummary && (quantity<=1 || !showOfferDataInputs)) {
    <span>@if (!offerDiscountToPosition) {
      ({{'CONFIGURATOR|Rabat' | translate}}: {{ price.discount}}%)
    }
  </span>
}
</span>
}
@if (configuratorOptions.mode !== 'layoutThumbnail' && price.price && price.discount === 0 && price.promotion === 0 && !price.hasGrossPrice && price.showPrice && !(isBlockedAddToOffer$  | async)) {
  <span id="price-nodiscount" [class.icc-ph-white]="translationLoading">
    {{ 'CONFIGURATOR|Cena netto' | translate }}: <span class="price">@if (price.listPriceAfterDiscountsInCurrency && price.listPriceAfterDiscountsInCurrency !== price.priceAfterDiscountsInCurrency) {
    <s>{{ price.listPriceAfterDiscountsInCurrency | currency: currency: '-' : false }}</s>
  } {{ price.priceAfterDiscountsInCurrency  | currency: currency : '-' : false }}</span>
</span>
}
@if (configuratorOptions.mode !== 'layoutThumbnail' && price.price && price.discount === 0  && price.promotion === 0 && price.hasGrossPrice && price.showPrice && !(isBlockedAddToOffer$  | async)) {
  <span id="price-nodiscount" [class.icc-ph-white]="translationLoading">
    {{ 'CONFIGURATOR|Cena' | translate }}: <span class="price">@if (price.listPriceAfterDiscountsInCurrency && price.listPriceAfterDiscountsInCurrency !== price.priceAfterDiscountsInCurrency) {
    <s>{{ price.listPriceAfterDiscountsInCurrency | currency: currency: '-' : false }}</s>
  } {{ price.priceAfterDiscountsInCurrency  | currency: currency : '-' : false }}</span>
</span>
}
@if (quantity > 1 && showOfferDataInputs && pricePerItemAfterDiscounts) {
  <span class='price-discount-unit-cost'>
    {{'CONFIGURATOR|Cena za szt.' | translate}}: @if (price.listPriceAfterDiscountsInCurrency && price.listPriceAfterDiscountsInCurrency !== price.priceAfterDiscountsInCurrency) {
    <s>{{ price.listPriceAfterDiscountsInCurrency | currency: currency: '-' : false }}</s>
    } {{ (price$ | async).priceAfterDiscountsInCurrency  | currency: currency : '-' : false }}
  </span>
}
@if (quantity > 1 && showOfferDataInputs && !pricePerItemAfterDiscounts) {
  <span class='price-discount-unit-cost'>
    {{'CONFIGURATOR|Cena za szt.' | translate}}: @if ((price$ | async).listPrice && (price$ | async).listPrice !== (price$ | async).price) {
    <s>{{ (price$ | async).listPrice | currency: currency }}</s>
    } {{ (price$ | async).price | currency: currency}}
  </span>
}
@if (configuratorOptions.mode !== 'layoutThumbnail' && price.price && price.hasGrossPrice && price.showPrice && !(isBlockedAddToOffer$  | async)) {
  <span id="price-info" [class.icc-ph-white]="translationLoading">{{ 'CONFIGURATOR|Wszystkie ceny zawierają VAT' | translate }}</span>
}
</div>
@if (showOfferDataInputs && !isHandset) {
  <div class="data-for-offer">
    <p>{{ 'CONFIGURATOR|Ilość' | translate }}</p>
    <mat-form-field>
      <input matInput (blur)='onQuantityChange($event.target.value)'  [value]='quantity' type="number" min='1'>
    </mat-form-field>
  </div>
}
@if (modalConfigurator) {
  <button mat-flat-button class="summary-button" color="primary"
    (click)="closeConfigurator()" [class.icc-ph-transparent]="translationLoading">
    {{ 'INTERFACE|Powrót' | translate }}
  </button>
}
@if ((!isHandset && !isTablet && !isSmallDesktop && !isFullscreen || preview || forceReturnButton) && returnButton && !modalConfigurator) {
  <button mat-flat-button class="summary-button" color="primary" [disabled]="!(savingButton$ | async)"
    (click)="saveConfiguration()" [class.icc-ph-transparent]="translationLoading">
    {{ RETURN_BUTTON_ENUM[returnButton] | translate}}
  </button>
}
@if ((isSmallDesktop || isTablet || isHandset || isFullscreen) && !openedPreview && !forceReturnButton) {
  <button mat-button class="summary-button-mobile" color="primary"
    (click)="openPreview()" [class.icc-ph-transparent]="translationLoading"
    >
    {{ 'CONFIGURATOR|Zobacz podgląd' | translate }}
  </button>
}
</div>
}
</ng-template>
